// Sheets configurator
$(document).ready(function () {

  // Mise à jour à l'arrivée sur la page
  $('.slider_sheets').on('init', function (slick) {
    update_sheets_element($(slick.target));
  });

  // Sliders
  $('.slider_sheets').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    arrows: false,
    fade: true,
    cssEase: "ease-out",
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false
        }
      }
    ]
  });

  // Id par défaut
  var default_id_1 = parseInt($('.sheets_1 .slick-current').attr("data-id"));
  var default_id_2 = parseInt($('.sheets_2 .slick-current').attr("data-id"));
  var default_id_3 = parseInt($('.sheets_3 .slick-current').attr("data-id"));

  $(".sheets_1").siblings(".sheets_options").find(".number").html(default_id_1);
  $(".sheets_2").siblings(".sheets_options").find(".number").html(default_id_2);
  $(".sheets_3").siblings(".sheets_options").find(".number").html(default_id_3);

  // Color par défaut
  var default_color_1 = $('.sheets_1 .slick-current').attr("data-color");
  var default_color_2 = $('.sheets_2 .slick-current').attr("data-color");
  var default_color_3 = $('.sheets_3 .slick-current').attr("data-color");
  $(".sheets_1").siblings(".sheets_options").find(".color").html(default_color_1);
  $('.sheets_1 option[value="' + default_color_1 + '"]').prop('selected', true);
  $(".sheets_2").siblings(".sheets_options").find(".color").html(default_color_2);
  $(".sheets_3").siblings(".sheets_options").find(".color").html(default_color_3);


  // Sheets choice
  $('.slider_sheets').on('afterChange', function (event, slick, currentSlide) {
    update_sheets_element($(this));
  });

  // Ecouteur changement de couleur
  $(".sheet_color input[type=radio]").change(function (e) {
    var $slider_to_move = $(this).parents(".sheets_options").siblings(".slider_sheets").first();
    var $index_to_move = $(this).parents('.js-color').index();
    $(this).parents('.sheets_options').find('.color_label span').html($(this).val());
    $slider_to_move.slick('slickGoTo', $index_to_move);
  });

  // Défini la couleur par défaut, cad la première
  $('.sheet_color input[type=radio]:checked').trigger("change");

  // Ecouteur sur le changement de taille
  $(document).on("change", ".sheet_size input[type=radio]", function (e) {
    // Désactivation de l'éventuel ancien sélectionné
    $(this).parents(".sheet_size").find("input[type=radio]").not(this).prev("label").removeClass("selected");

    // Activation du label de l'option sélectionnée
    $(this).prev("label").addClass("selected");

    // Mise à jour du prix indiqué pour cette option
    var compare_at_price = parseFloat($(this).data("compare_at_price"));
    var qty_to_add = parseFloat($(this).data("qty_to_add"));
    var price = parseFloat($(this).data("price"));
    var price_html = '';

    if (compare_at_price && parseFloat(compare_at_price) > parseFloat(price)) {
      var percentage = 100 - Math.floor((100 * price) / compare_at_price);
      price_html = '<span class="discount"><span>' + compare_at_price + ' €</span> <strong>-' + percentage + '%</strong></span> <span class="price">' + price + '</span> €' + (qty_to_add > 1 ? ' x ' + qty_to_add : '');
    }
    else price_html = '<span class="price">' + price + '</span> €' + (qty_to_add > 1 ? ' x ' + qty_to_add : '');

    $(this).parents(".step").find(".price_wrapper").html(price_html ? price_html : "");

    // Total de la parure de lit
    total_sheets_elements();
  });

  /**
   * Met à jour le dom avec le liste des variants en fonction du slide sélectionné, pour un slider donné en paramètre
   * @param {*} $slider Element jquery sur lequel un slider est appliqué
   */
  function update_sheets_element($slider) {
    // Update l'id du drap
    var sheet_id = parseInt($slider.find('.slick-current').attr("data-id"));

    //$slider.siblings(".sheets_options").find(".number").html(sheet_id);

    // Update la couleur du drap
    var sheet_color = $slider.find('.slick-current').attr("data-color");
    $slider.siblings(".sheets_options").find(".color").html(sheet_color);
    $slider.siblings(".sheets_options").find('input[value="' + sheet_color + '"]').prop('checked', true).trigger("change");

    // Récupération du wrapper de la zone
    var $wrapper = $slider.parent(".step");

    // Récupération du produit sélectionné dans le slider
    var current_product_id = parseInt($wrapper.find('.slick-current').attr("data-shopify_id"));

    // Récupération des variants du produit concerné, pour la collection concernée
    var current_collection = $wrapper.data("collection");
    var product_variants = json_sheets_products[current_collection][current_product_id];

    // Construction du markup HTML de remplacement de la liste des options (ici des tailles)
    var options_selector_html = '';
    var price_html = '';
    var already_selected = false;

    var site_lng = $("html").attr("lang");
    var is_simple_product = product_variants.length == 1;

    $.each(product_variants, function (k, v) {
      var label_args = '', input_args = '';

      // Gestion des options en fonction de la disponibilté du variant
      if (!v.option_stock) {
        label_args += ' class="no_stock"';
        input_args += ' disabled';
      }
      else if (!already_selected) {
        label_args += ' class="selected"';
        input_args += ' checked';
        already_selected = true;

        price_html += (site_lng == "fr" ? 'Ajouter au panier' : 'Add to cart') + ' - <span class="price_wrapper">';

        // Gestion du prix
        if (v.option_compare_at_price && parseFloat(v.option_compare_at_price) > parseFloat(v.option_price)) {
          var percentage = 100 - Math.floor((100 * v.option_price) / v.option_compare_at_price);
          price_html += '<span class="discount"><span>' + v.option_compare_at_price + ' €</span> <strong>-' + percentage + '%</strong></span> <span class="price">' + v.option_price + '</span> €' + (v.option_qty_to_add > 1 ? ' x ' + v.option_qty_to_add : '');
        }
        else price_html += '<span class="price">' + v.option_price + '</span> € ' + (v.option_qty_to_add > 1 ? ' x ' + v.option_qty_to_add : '');

        price_html += '</span>';
      }

      // Html de la liste
      options_selector_html += '<label' + label_args + ' for="opt_' + v.option_id + '">' + v.option_name + '</label> <input type="radio" id="opt_' + v.option_id + '" data-price="' + v.option_price + '" data-qty_to_add="' + v.option_qty_to_add + '" data-compare_at_price="' + v.option_compare_at_price + '" value="' + v.option_id + '" name="' + current_collection + '_sizing"' + input_args + ' style="display:none" />';
    });

    // Application dans le dom
    $wrapper.find(".sheet_size span").html(options_selector_html);

    if (is_simple_product) {
      $wrapper.find(".sheet_size").css("opacity", "0");
      $wrapper.find(".sheet_size span").hide();
    }
    else {
      $wrapper.find(".sheet_size").css("opacity", "1");
      $wrapper.find(".sheet_size span").show();
    }

    // Calcul et mise à jour du prix total
    total_sheets_elements();
  }

  /**
   * Mise à jour du bouton "Acheter l'ensemble"
   */
  function total_sheets_elements() {
    var total = 0;
    var total_compared = 0;

    $(".sheet_size input[type=radio]:checked").each(function () {
      total += parseFloat($(this).data("price")) * parseInt($(this).data("qty_to_add"));

      if (parseFloat($(this).data("compare_at_price")) > 0) {
        total_compared += parseFloat($(this).data("compare_at_price")) * parseInt($(this).data("qty_to_add"));
      }
      else {
        total_compared += parseFloat($(this).data("price")) * parseInt($(this).data("qty_to_add"));
      }
    });

    if (total_compared > total) {
      $(".all_price .price").html(" - " + total.toFixed(2).replace(".00", "") + " € <s>" + total_compared.toFixed(2).replace(".00", "") + " € </s>").show();
      $("h1 .price").html(" - " + total.toFixed(2).replace(".00", "") + " € <s>" + total_compared.toFixed(2).replace(".00", "") + " € </s>").show();
    }
    else {
      $(".all_price .price").html(" - " + total.toFixed(2).replace(".00", "") + " €").show();
      $("h1 .price").html(" - " + total.toFixed(2).replace(".00", "") + " €").show();
    }
  }

  /** Ajout au panier **/
  // Ajout élément par élément
  $('button[data-action=add-to-cart-single]').click(function (e) {
    e.preventDefault();

    var products = [];

    // Récupération du variant sélectioné
    var $selected_product = $(this).parents('.step').find('.sheet_size input[type=radio]:checked').first();

    // Si un produit associé au bouton est sélectionné
    if ($selected_product.length) {
      const quantity = $selected_product.data("qty_to_add");
      products.push({ id: $selected_product.val(), quantity });

      jQuery.post('/cart/add.js', {
        items: products
      }, function (result) {
        update_header_cart();

        /* TRACKING GTM */
        dtlAddToCart({ handle: result.items[0]?.handle, quantity, variant: { id: result.items[0]?.variant_id, title: result.items[0]?.variant_title } })
      }, 'json');
    }
    // Fallback : Rafraichissement de la page sans rien faire
    else window.location.href = window.location.href;
  });

  // Ajouter tous les éléments sélectionnés
  $('button[data-action=add-to-cart-full]').click(function (e) {
    e.preventDefault();

    var products = [];

    // Récupération du variant sélectioné
    var $selected_products = $(".sheet_size input[type=radio]:checked");

    // Si un produit associé au bouton est sélectionné
    if ($selected_products.length) {
      $selected_products.each(function (k, v) {
        products.push({ id: $(this).val(), quantity: $(this).data("qty_to_add") });
      });

      const items = products.reverse() // On renverse le tableau pour que les élements du panier soit dans le même ordre que la sélection

      jQuery.post('/cart/add.js', {
        items
      }, function (result) {
        update_header_cart();

        /* TRACKING GTM */
        result.items.forEach((item, i) => {
          dtlAddToCart({ handle: item.handle, quantity: items[i]?.quantity, variant: { id: items[i]?.variant_id, title: items[i]?.variant_title } })
        });
      }, 'json');
    }
    // Fallback : Rafraichissement de la page sans rien faire
    else window.location.href = window.location.href;
  });
});
